import React from 'react'
import { useFilters } from './FilterContext';

function MobilePopup() {
  const { mobilePopUpData, setopenPopup, openPopup } = useFilters();

  if (!openPopup) return null; // don’t render anything if popup is closed

  return (
    <div className='mobile-popup'>
      <div className='mobile-wrapper'>
        <div className='popup-content'>
          {mobilePopUpData}
        </div>
        <span  className='popup-close'
          style={{ cursor: "pointer" }}
          onClick={() => {
            setopenPopup(false);
            document.body.style.overflow = 'visible'; // restore scroll
          }}
        >
          <img src="https://www.ourgreenhouse.com/content/close.png" alt="close-icon" />
        </span>
      </div>
    </div>
  );
}

export default MobilePopup;
